// Vleescentrum (VCE) Constants
export const VCE_CONSTANTS = {
  COMPANY_NAME: "Het Vleescentrum",
  STREET_AND_NUMBER: "De Hoek 91A",
  ZIP_AND_CITY: "1601MR, Enkhuizen",
  COUNTRY: "Nederland",
  KVK: "72794380",
  VAT: "NL859239056B01",
  WEBSITE_URL: "hetvleescentrum.nl",
  WEBSITE_NAME: "Het Vleescentrum",
  LOGO_SRC: "/img/logo-vleescentrum.webp",
  REVIEW_QR_CODE: "/img/qr-code/review-vleescentrum.png",
};

// Halalvlees Online (HVO) Constants
export const HVO_CONSTANTS = {
  COMPANY_NAME: "Halalvlees Online",
  STREET_AND_NUMBER: "De Hoek 91A",
  ZIP_AND_CITY: "1601MR, Enkhuizen",
  COUNTRY: "Nederland",
  KVK: "72794380",
  VAT: "NL859239056B01",
  WEBSITE_URL: "halalvlees-online.nl",
  WEBSITE_NAME: "Halalvlees Online",
  LOGO_SRC: "/img/logo-hvo.png",
  REVIEW_QR_CODE: "/img/qr-code/review-hvo.png", // Update this if HVO has a different QR code
};

/**
 * Get company constants based on shop source
 * @param {string} shopSource - "VCE" or "HVO"
 * @returns {Object} Company constants
 */
export const getCompanyConstants = (shopSource) => {
  return shopSource === "VCE" ? VCE_CONSTANTS : HVO_CONSTANTS;
};

// Backward compatibility - default to VCE
export const COMPANY_CONSTANTS = VCE_CONSTANTS;
export const LOGO_SRC = VCE_CONSTANTS.LOGO_SRC;
export const REVIEW_QR_CODE = VCE_CONSTANTS.REVIEW_QR_CODE;
export const LOGO_SRC_VLEESCENTRUM = VCE_CONSTANTS.LOGO_SRC;
export const REVIEW_QR_CODE_VLEESCENTRUM = VCE_CONSTANTS.REVIEW_QR_CODE;
